try {
    sessionStorage.setItem(
        'Neos.Neos.lastVisitedNode',
        document.querySelector('meta[name="neos-node"]').getAttribute('content')
    );
} catch (e) {}
